{
	"type": "line",
	"minzoom": 11,
	"layout": { "line-cap": "round" },
	"paint": {
		"line-color": "#3b3b3b",
		"line-width": ["interpolate", ["linear"], ["zoom"], 11, 2, 18, 5],
		"line-offset": [
			"interpolate",
			["linear"],
			["zoom"],
			11,
			["match", ["get", "visual_offset"], "Left", -4, "Right", 4, 0],
			18,
			["match", ["get", "visual_offset"], "Left", -12, "Right", 12, 0]
		]
	}
}
